<script>
    import { formatNumber, getCurrencySymbol, isNumber, parseNumber } from 'intl-utils';

    export default function(props = {}) {
        const root = this;
        let value;

        return {
            defaultCurrency: props.defaultCurrency ?? config.baseCurrency,
            exTaxText: props.exTaxText,
            incTaxText: props.incTaxText,
            editingIncTax: false,
            incTaxValue: '',
            get locale() {
                return props.locale ?? config.locale;
            },
            get taxRate() {
                return props.taxRate ?? 0;
            },
            get displayExTax() {
                return props.displayExTax ?? true;
            },
            get displayIncTax() {
                return props.displayIncTax ?? true;
            },
            get displayLabels() {
                return props.displayLabels ?? true;
            },
            // This cannot be called "value" otherwise it prevents a data-bound value with the same name.
            get _value() {
                // If the "value" property is a getter then it is referencing an outer variable so we should always get it.
                return value = value === undefined || Object.getOwnPropertyDescriptor(props, 'value').get !== undefined ? props.value : value;
            },
            set _value(val) {
                value = val;

                this.$refs.root.dispatchEvent(new CustomEvent('update:value', { detail: value }));

                // Update the value and invoke the change event. Note: This must be the change event to not interfere with the Vue.js input event.
                this.$refs.value.value = value ?? '';
                this.$refs.value.dispatchEvent(new Event('change', { bubbles: true }));
            },
            // This cannot be called "amount" otherwise it prevents a data-bound value with the same name.
            get _amount() {
                return this._value != null ? (this._value.includes(' ') ? this._value.split(' ')[0] : this._value) : null;
            },
            get currency() {
                return this._value != null ? (this._value.includes(' ') ? this._value.split(' ')[1] : config.currency) : this.defaultCurrency;
            },
            get currencySymbol() {
                return getCurrencySymbol(this.currency, this.locale);
            },
            get exTax() {
                return this._amount ?? '';
            },
            set exTax(value) {
                this._value = value != '' ? `${value} ${this.currency}` : null;
            },
            get incTax() {
                // If editing then return the current raw value.
                if (this.editingIncTax)
                    return this.incTaxValue;

                return isNumber(this._amount, this.locale) ? `${formatNumber(parseNumber(this._amount, this.locale) / 100 * (100 + this.taxRate), {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 5,
                    useGrouping: false
                }, this.locale)}` : '';
            },
            set incTax(value) {
                this.incTaxValue = value;
                this._value = isNumber(value, this.locale) ? `${formatNumber(parseNumber(value, this.locale) * 100 / (100 + this.taxRate), {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 5,
                    useGrouping: false
                }, this.locale)} ${this.currency}` : null;
            },
            onIncTaxFocus() {
                this.incTaxValue = this.incTax;
                this.editingIncTax = true;
            },
            onIncTaxBlur() {
                this.editingIncTax = false;
            },
            mounted(element, data = this) {
                // This makes sure this component is reset when the reset event is triggered against any parent element (not just a form). See https://jsfiddle.net/ojq0crft/ for why we specify true at the end.
                document.addEventListener('reset', this.reset, true);

                // Call the root mounted method.
                root.mounted(element, data);
            },
            unmounted(element, data = this) {
                // Remove the reset event handler.
                document.removeEventListener('reset', this.reset, true);

                // Call the root unmounted method.
                root.unmounted(element, data);
            },
            reset(e) {
                // Make sure the target contains the element.
                if (e.target.contains(this.$refs.root))
                    this._value = null;
            }
        };
    }
</script>